import clsx from "clsx";
import { FC } from "react";
import styles from "./styles.module.scss";

interface Props {
  type: "Feedback" | "Issue";
}

const FeedbackType: FC<Props> = ({ type }): JSX.Element => {
  return (
    <div
      className={clsx(styles.wrapper, {
        [styles.feedbackWrapper]: type === "Feedback",
        [styles.issueWrapper]: type === "Issue",
      })}
    >
      <span>{type === "Issue" ? "Issue" : "Feedback"}</span>
    </div>
  );
};

export default FeedbackType;
